export default __webpack_public_path__ + "static/media/Profile.0f4141ce.png";